// @flow
import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import path from 'ramda/es/path';
import clone from 'ramda/es/clone';
import { useDispatch } from 'react-redux';

// import Loading from 'app/common/components/Loader';
// $FlowFixMe
import shopApi from 'app/actions/shopApi';
import action from 'app/common/lib/action';
import RowLayout, { Space } from 'app/common/layouts/RowLayout';

import styles from './PaymentFrame.module.scss';;


type Props = {
  orderId: string,
  onFrameUpdate?: () => void,
};

const PaymentFrame = ({ orderId, onFrameUpdate }: Props) => {
  const { t } = useTranslation('shop');
  const [payUrl, setPayUrl] = useState('');
  const dispatch = useDispatch();

  const requestPayUrl = useCallback(async () => {
    const requestPath = `orders/${orderId}/pay`;
    try {
      const res = await shopApi(requestPath, 'post');
      const url = path(['data', 'data', 'formUrl'], res);
      setPayUrl(url);
      return true;
    } catch (error) {
      const errorSave = {
        err: t('error_api_pay'),
        path: requestPath,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
      return false;
    }
  }, [dispatch, t, orderId]);

  const handleMessage = useCallback(({ data }: { data: Object }) => {
    if (data === 'STORE:FRAME_CONTENT_LOADED' && onFrameUpdate) {
      onFrameUpdate();
    }
  }, [onFrameUpdate]);

  useEffect(() => {
    requestPayUrl();
    if (window.addEventListener) {
      window.addEventListener('message', handleMessage, false);
    } else if (window.attachEvent) { // ie8
      window.attachEvent('onmessage', handleMessage);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Fragment>
      <Space />
      <RowLayout className={styles.frameContent} paddingfree>
        {/* <div className={styles.loader}>
          <Loading />
        </div> */}
        {payUrl
          && <iframe src={payUrl} className={styles.frame} scrolling="no" title="Банк">
            {t('no_frames_warning')}
          </iframe>}
      </RowLayout>
    </Fragment>
  );
};

export default PaymentFrame;
